"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var util_1 = require("@aperza/util");
var SuggestPopUp = /** @class */ (function (_super) {
    __extends(SuggestPopUp, _super);
    function SuggestPopUp(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showSuggest: false,
        };
        return _this;
    }
    SuggestPopUp.prototype.onClick = function () {
        var isSearchResult = util_1.AppConfigService.isAperzaSearchResultPage();
        var isSearchNewsResult = util_1.AppConfigService.isAperzaSearchNewsResultPage();
        if (!isSearchResult && !isSearchNewsResult) {
            if (this.props.onClick) {
                this.props.onClick();
            }
        }
    };
    SuggestPopUp.prototype.onMouseOver = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    SuggestPopUp.prototype.render = function () {
        var suggest = this.props.suggest;
        var showSuggest = this.state.showSuggest;
        var isSearchResult = util_1.AppConfigService.isAperzaSearchResultPage();
        var isSearchNewsResult = util_1.AppConfigService.isAperzaSearchNewsResultPage();
        var suggestPopUpStyle = {
            display: showSuggest ? 'block' : 'none',
        };
        suggestPopUpStyle = {
            display: 'none',
        };
        return (react_1.default.createElement("div", { className: "suggest-popup" },
            react_1.default.createElement("div", { className: clsx_1.default('suggest-popup-button', {
                    inactive: showSuggest || isSearchResult || isSearchNewsResult,
                }), onClick: this.onClick.bind(this) },
                react_1.default.createElement("i", { className: "fa fa-search", "aria-hidden": "true" })),
            react_1.default.createElement("div", { className: "suggest-popup-modal", style: suggestPopUpStyle, onMouseOver: this.onMouseOver.bind(this) }, suggest)));
    };
    SuggestPopUp.propTypes = {
        suggest: prop_types_1.default.any.isRequired,
        onClick: prop_types_1.default.func,
    };
    return SuggestPopUp;
}(react_1.Component));
exports.default = SuggestPopUp;
